import React, { useState } from 'react';
import { Col, FormControl, InputGroup, Row } from 'react-bootstrap';
import '../../../styles/RegDashboard.css';
import { HHIEButton } from '../../utility/HHIEButton';

export function AdminDashSearch(props) {
    const [searchValue, setSearchValue] = useState("");

    return (
        <Row>
            <Col className="style-search d-flex justify-content-center">
                <InputGroup class-name="mb-3">
                    <FormControl
                        id="account-name-search"
                        placeholder="Organization Name"
                        aria-label="Organization Name"
                        aria-describedby="account-name-search"
                        style={{borderRadius: '10px', marginRight: '4px'}}
                        onChange={(e) => { setSearchValue(e.target.value) }}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                props.handleSearchClick(searchValue);
                            }
                        }}
                    />
                    <HHIEButton 
                        variant="primary" 
                        id="search-button" 
                        onClick={() => { props.handleSearchClick(searchValue) }}
                        title="Search"
                        size="sm"
                    />
                </InputGroup>
            </Col>
        </Row>

    );
}
